<template>
  <div class="detail-container"
  v-loading="loading">
    <Header></Header>
    <div class="detail">
      <div class="detail-header">
        <div class="detail-tabs">
          <Tabs
          @changeSubject="changeSubject"
          :subject_list="subject_list"
          :activeId="activeId"></Tabs>
        </div>
        <div class="detail-header_class">
          <span >{{className}}</span>
          <el-dropdown trigger="click" @command="changeClass">
            <span class="el-dropdown-link">
              <i
                class="el-icon-refresh el-icon--left"
              ></i
              >切换班级
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
              :class="{active:item.class_name===className}"
              v-for="(item,index) in classList" :key="index" :divided="index>0"
              :command="item.class_name"
              >{{item.class_name}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="detail-wrap">
        <div class="detail-wrap_di"><img src="../images/di.png" alt="" /></div>
        <div class="detail-wrap_title">未完成的测评</div>
      </div>
      <unfinished-test :activeId="activeId" :unfinishedList="unfinishedList"></unfinished-test>
      <div class="detail-wrap">
        <div class="detail-wrap_un"><img src="../images/di.png" alt="" /></div>
        <div class="detail-wrap_title">已完成的测评</div>
      </div>
      <finished-content :activeId="activeId" :finishedList="finishedList"></finished-content>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import FinishedContent from '../components/finished-content.vue';
import UnfinishedTest from '../components/unfinished-test.vue';
import Tabs from '../components/tabs.vue';
import Header from '../components/header.vue';
import api from '@/pages/dl-web/api/api';
import { getSign } from '@/pages/dl-web/utils/verify';
export default {
  name:'DlDetail',
  data() {
    return {
      userName: '',//用户名
      activeId: '0',// 当前点击的id
      list: [], // 测试列表
      params: {}, // 测试列表参数
      classList: [], // 班级列表
      subjectList: [], // 科目列表
      className:'',// 显示班级名称
      class_name:'',//班级名
      lastInfo:{},//最后一次班级测评的信息
      loading:false//加载
    };
  },
  components: {
    UnfinishedTest,
    FinishedContent,
    Tabs,
    Header,
  },
  created() {
    this.getTestInfo();
  },
  methods: {
    // 切换科目
    changeSubject(subjectId) {
      this.activeId = subjectId;
    },
    //获取测评列表
     async getTestInfo() {
      this.loading=true
      this.params.time_stamp = (new Date()).getTime();
      this.params.sign = getSign(this.params);
      try {
      const res = await api.getTestInfo(this.params)
      this.userName = localStorage.getItem('real_name')
      this.list = res.data.list || []
      this.classList = res.data.class_list || []
      this.subjectList = res.data.subject_list || {}

      //获取上次测试的班级信息
      const result = await api.getLastInfo(this.params);
      this.lastInfo = result.data
      console.log(result.data.class_name)
      this.className =
      result.data.class_name || this.classList[0].class_name || ''
      } catch (error) {
        console.log(error)
      } finally{
        this.loading = false
      }
    },
    // 切换班级
    changeClass(command) {
      console.log(command)
      this.className  = command
      this.activeId = '0'
    },
  },
   computed: {
     // 获取展示的科目列表
    subject_list() {
      const newData = [];
      for (const key in this.subjectList) {
        newData.push({
          subjectId: key,
          subjectName: this.subjectList[key],
        });
      }
      return newData
    },
     //测评列表
    testList() {
      let arrList =  this.list.filter(item=>item.class_name===this.className)
       return arrList.sort(function(a, b) {
          return b.created < a.created ? -1 : 1
      })
    },
    // 未完成列表
    unfinishedList() {
      return this.testList.filter(item=>item.evaluate_status===2)
    },
    // 已完成列表
    finishedList() {
      let arr = this.testList.filter(item=>item.evaluate_status===1)
      return arr.sort(function(a, b) {
          return b.end_time < a.end_time ? -1 : 1
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.detail-container {
  padding-top: 64px;
  padding-bottom:54px ;
}
.detail {
  width: 1118px;
  max-width: 100%;
  margin: 16px auto;
  background: #fff;
  padding: 0 19px 0 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  &-header {
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
    &_class {
      span {
        font-size: 16px;
        font-weight:500;
        color: #000000;
      }
    }
    .el-dropdown-link {
      font-size: 14px;
      color: #1989FA;
      margin-left:22px;
      cursor: pointer;
    }
  }
  &-wrap {
    width: 100%;
    height: 51px;
    position: relative;
    &_di {
      margin-top: 24px;
    }
    &_un {
      margin-top: 6px;
    }
    &_title {
      position: absolute;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      top: 5px;
      left: 13px;
    }
  }
}
.el-dropdown-menu{
font-weight: 500;
color: #010101;
}
.el-icon-refresh:before{
  font-weight:500 ;
}
.active{
  color: #1989FA;
}
</style>
